<template>
  <div class="filter-multiselection-tree-option">
    <slot :option="option"
          :createURL="createURL"
          :optionParentClasses="optionParentClasses"
          :filterName="filterName">
      <a :href="createURL(option.value)"
         :class="optionParentClasses"
         @click.prevent="$emit('select', option.value)">
        {{ filterName }}
      </a>
    </slot>

    <div v-if="active && option.data"
         class="filter-multiselection-tree-option__children">
      <filters-multiselection-tree-option v-for="childOption in option.data"
                                          :key="childOption.value"
                                          :option="childOption"
                                          v-bind="$props"
                                          @select="$emit('select', $event)">
        <template v-for="(_, slot) of $scopedSlots"
                  v-slot:[slot]="scope">
          <slot :name="slot"
                v-bind="scope"/>
        </template>
      </filters-multiselection-tree-option>
    </div>
  </div>
</template>

<script>
import { last, upperFirst } from 'lodash'

export default {
  name: 'FiltersMultiselectionTreeOption',
  props: {
    filter: {
      type: Object,
      required: true
    },
    option: {
      type: Object,
      required: true
    },
    mobile: {
      type: Boolean,
      default: false
    },
    createURL: {
      type: Function,
      default: () => {}
    },
    showCount: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    active () {
      return this.option.isRefined
    },
    filterName () {
      const { label, count } = this.option
      let filterName = `${this.filter.name === 'category' ? this.getNameFromPermalink(label) : label}`
      if (this.showCount) return `${filterName} (${count})`

      return filterName
    },
    optionParentClasses () {
      return {
        'filter-multiselection-tree-option__parent': !this.mobile,
        'filter-multiselection-tree-option__parent--active': !this.mobile && this.active,
        btn: this.mobile,
        inverted: this.mobile && !this.active
      }
    }
  },
  methods: {
    getNameFromPermalink (permalink) {
      return last((permalink).split('/'))
                   .replace(/-and-/, ' & ')
                   .replace(/-/g, ' ')
                   .replace(/[^\s]+/g, upperFirst)
    }
  }
}
</script>

<style scoped lang="scss">
 @import '@/assets/stylesheets/variables';

 $option-height: 44px;

.filter-multiselection-tree-option {
  .btn {
    margin-bottom: 10px;
    white-space: normal;
    width: 89%;

    &:active, &:hover, &:visited {
      color: $color-white;
    }

    &.inverted {
      &:active, &:hover, &:visited {
        color: $secondary;
      }
    }
  }

  &__parent {
    height: $option-height;
    font-size: 1.6rem;
    letter-spacing: 0.38px;
    text-align: center;
    border: 1px solid $color-gray-multiselection;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    line-height: 20px;
    width: 248px;

    &--active {
      background-color: $secondary;
      color: $color-white;
      &:before {
        background-color: $color-white;
      }

      .filter-multiselection-tree-option__non-returnable {
        filter:
          invert(97%)
          sepia(100%)
          saturate(0%)
          hue-rotate(186deg)
          brightness(110%)
          contrast(101%);

        &:hover {
          filter:
            invert(51%)
            sepia(10%)
            saturate(1642%)
            hue-rotate(321deg)
            brightness(95%)
            contrast(87%);
        }
      }
    }
  }

  &__children-toggle-wrapper {
    display: flex;
    align-items: center;
  }

  &__children-toggle-cover {
    box-sizing: border-box;
    width: 29px;
  }

  &__children {
    margin-top: 10px;
    padding-left: 46px;
    display: grid;
    row-gap: 10px;
  }
}
</style>
